import React from 'react'

import NewGamesPolling from './NewGamesPolling'
import TopSlotsPolling from './TopSlotsPolling'

const ExternalGamesPolling: React.FC = () => (
  <>
    <NewGamesPolling />
    <TopSlotsPolling />
  </>
)

export default ExternalGamesPolling
